var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavAncestry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "21px",
    viewBox: "0 0 29 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Internal-Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile_01_Dashboard",
    transform: "translate(-227.000000, -2175.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(-7.000000, 2150.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#E9E9E9",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 390,
    height: 81,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(234.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,0 C14.7467051,0 19,4.25329488 19,9.5 C19,14.7467051 14.7467051,19 9.5,19 C4.25329488,19 0,14.7467051 0,9.5 C0,4.25329488 4.25329488,0 9.5,0 Z M9.5,7 C8.11928813,7 7,8.11928813 7,9.5 C7,10.8807119 8.11928813,12 9.5,12 C10.8807119,12 12,10.8807119 12,9.5 C12,8.11928813 10.8807119,7 9.5,7 Z",
    id: "Combined-Shape",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#9AE0EA",
    cx: 21.5,
    cy: 13.5,
    r: 6.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavAncestry);
export default __webpack_public_path__ + "static/media/nav-ancestry.93244e55eb4f8ed4239a5dd84f2723e0.svg";
export { ForwardRef as ReactComponent };